import { gql } from "@apollo/client";

export const CREATE_SUPPLIER = gql`
  mutation CreateSupplier($input: createSupplierInput) {
    createSupplier(input: $input) {
      supplierId
      supplierName
      contactDetails
      rating
      purchaseHistory
      contractTerms
      paymentTerms
    }
  }
`;






